import EditPaymentMethodForm from './EditPaymentMethodForm';

export default EditPaymentMethodForm;
